import {
  Component,
  ComponentRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {CurrentUserViewModel} from '../../../../core/models/current-user.view-model';
import {SocialDataProviderService} from '../../../timeline/social-grid-list/social-data-provider.service';
import {SocialListItemRenderer} from './social-list-item-renderer.interface';
import {SocialListReactionRemoval} from './social-list-modal-config.interface';

@Component({
  selector: 'app-social-list-item-host',
  template: '<ng-template #host></ng-template>'
})
export class SocialListItemHostComponent implements OnChanges, OnDestroy {
  @Input() public componentType: Type<SocialListItemRenderer<any>>;
  @Input() public item: any;
  @Input() public currentUser: CurrentUserViewModel;
  @Input() public socialDPS: SocialDataProviderService;
  @Input() public navigateTo: (item: any) => void;
  @Input() public swiperConfig: any;
  @Input() public rendererInputs: Record<string, unknown> | undefined;
  @Input() public reactionRemoval?: SocialListReactionRemoval;

  @ViewChild('host', {read: ViewContainerRef, static: true}) private readonly host!: ViewContainerRef;

  private componentRef: ComponentRef<SocialListItemRenderer<any>> | null = null;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.componentType) {
      this.renderComponent();
      return;
    }

    this.syncInputs();
  }

  public ngOnDestroy(): void {
    this.componentRef?.destroy();
  }

  private renderComponent(): void {
    this.host.clear();
    this.componentRef?.destroy();
    this.componentRef = null;

    if (!this.componentType) {
      return;
    }

    this.componentRef = this.host.createComponent(this.componentType);
    this.syncInputs();
  }

  private syncInputs(): void {
    if (!this.componentRef) {
      return;
    }

    this.componentRef.instance.item = this.item;
    this.componentRef.instance.currentUser = this.currentUser;
    this.componentRef.instance.socialDPS = this.socialDPS;
    this.componentRef.instance.navigateTo = this.navigateTo;
    this.componentRef.instance.swiperConfig = this.swiperConfig;
    this.componentRef.instance.rendererInputs = this.rendererInputs;
    this.componentRef.instance.reactionRemoval = this.reactionRemoval;
    this.componentRef.changeDetectorRef.detectChanges();
  }
}
